/**
 * Blob material overrides by “variant” — same merge as chat (`EthicalDimensionVis`).
 * Persona presets supply motion / transmission; these keys tune PBR read under IBL.
 */
export const BLOB_VARIANT_CONFIG_OVERRIDES = {
  default: {
    roughness: 0.18,
    metalness: 0.08,
    envMapIntensity: 1.9,
    clearcoat: 0.5,
    clearcoatRoughness: 0.15,
  },
  /** Intro / mobile landing cards: vivid ethical colors, slightly softer IBL than chat `default`. */
  landing: {
    roughness: 0.2,
    metalness: 0.1,
    envMapIntensity: 1.35,
    clearcoat: 0.45,
    clearcoatRoughness: 0.18,
  },
  geometric: {
    uPositionFrequency: 1.6,
    uPositionStrength: 0.55,
    uSmallWavePositionFrequency: 1.2,
    uSmallWavePositionStrength: 0.45,
    uSmallWaveTimeFrequency: 0.3,
    uTimeFrequency: 0.55,
    roughness: 0.18,
    metalness: 0.12,
    envMapIntensity: 2.0,
    clearcoat: 0.45,
    clearcoatRoughness: 0.2,
  },
  fluid: {
    uPositionFrequency: 0.8,
    uPositionStrength: 0.35,
    uSmallWavePositionFrequency: 0.5,
    uSmallWavePositionStrength: 1.0,
    uSmallWaveTimeFrequency: 0.45,
    uTimeFrequency: 0.65,
    roughness: 0.3,
    metalness: 0.02,
    envMapIntensity: 1.8,
    clearcoat: 0.35,
    clearcoatRoughness: 0.25,
  },
  crystalline: {
    uPositionFrequency: 1.3,
    uPositionStrength: 0.25,
    uSmallWavePositionFrequency: 2.0,
    uSmallWavePositionStrength: 0.3,
    uSmallWaveTimeFrequency: 0.18,
    uTimeFrequency: 0.25,
    roughness: 0.06,
    metalness: 0.1,
    transmission: 0.4,
    clearcoat: 0.8,
    clearcoatRoughness: 0.2,
    envMapIntensity: 2.3,
  },
};

export function mergeBlobVariantConfig(baseConfig, variant = 'default') {
  const overrides =
    BLOB_VARIANT_CONFIG_OVERRIDES[variant] || BLOB_VARIANT_CONFIG_OVERRIDES.default;
  return { ...baseConfig, ...overrides };
}

/** GIF export uses a white backing — wireframe presets (e.g. Afterlife Archive) vanish in capture. */
export function mergeLandingGifCaptureConfig(baseConfig) {
  return { ...baseConfig, wireframe: false };
}
